import { render } from "./OrganizationListPage.vue?vue&type=template&id=f991a380"
import script from "./OrganizationListPage.vue?vue&type=script&lang=js"
export * from "./OrganizationListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__